import { render, staticRenderFns } from "./Signer.vue?vue&type=template&id=3281e12c&"
import script from "./Signer.vue?vue&type=script&lang=js&"
export * from "./Signer.vue?vue&type=script&lang=js&"
import style0 from "./Signer.vue?vue&type=style&index=0&id=3281e12c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports